import { ChipProps as MuiChipProps } from '@material-ui/core';
import { nanoid } from 'nanoid';
import * as React from 'react';

export type ChipProps = MuiChipProps;

export const CHIP_UUID = nanoid();

export type ChipType = React.FC<ChipProps>;
